import React, { FunctionComponent, useContext } from 'react';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { ReactComponent as MixlrLogo } from 'images/mixlr-logo.svg';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { useLocation, matchPath } from 'react-router-dom';
import { useAppSelector } from 'hooks/redux';

export const PoweredBy: FunctionComponent = () => {
  const url = process.env.REACT_APP_WEBSITE_ENDPOINT;
  const { isNativeAppWebview } = useContext(UserAgentContext);
  const channelHomepageEnabled = useAppSelector(
    (state) => state.channel.channelDetails?.channelHomepageEnabled
  );
  const networkOwner = useAppSelector(
    (state) => state.channel.channelDetails?.networkOwner
  );
  const { pathname } = useLocation();
  const isEventPath = matchPath('/events/:id', pathname);
  const isRecordingPath = matchPath('/recordings/:id', pathname);

  if (isNativeAppWebview) {
    return null;
  }

  if (channelHomepageEnabled && (isEventPath || isRecordingPath)) {
    return null;
  }

  if (networkOwner) {
    return null;
  }

  return (
    <div
      className={classNames(styles['powered-by'], {
        [styles['powered-by--non-live']]: !channelHomepageEnabled
      })}
    >
      <a
        href={`${url}?source=${window.location.origin}`}
        className={styles['powered-by__logo']}
        target="_blank"
        rel="noreferrer"
      >
        Powered by <MixlrLogo />
      </a>
    </div>
  );
};
